// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#admin-dashboard,
#admin-header,
#transcripts-react,
#ilt-calendar,
#dashboard {
  font-family: Calibri, sans-serif;
  font-size: 1.4em;
  .main-section {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

#admin-dashboard {
  /* Setting min-height in order to force the footer to be below the dashboard. Also see #admin-dashboard__body */
  min-height: 500px;
  width: 100vw;

  .react-grid-item.react-grid-placeholder {
    background: #1eabe3;
  }

  .react-resizable-handle-se {
    margin-bottom: -2px;
    margin-right: 5px;
  }

  .page-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

#admin-header {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  min-height: 100px;

  .hamburger-container {
    bottom: 0;
    border-bottom: 1.5px solid lightgray;
    padding: 0.5em 1em;
    width: 3em;
  }

  .admin-logo-container {
    border-bottom: 1.5px solid lightgray;
    padding-bottom: 0.5em;
    padding-top: 0.5em;
  }

  &.universal-header-enabled .admin-logo-container {
    display: none !important;
  }

  &.universal-header-enabled .hamburger-container {
    width: 5em !important;
  }

  .tab {
    border-radius: 5px 5px 0 0;
    font-family: Calibri, sans-serif;
    font-size: 16px;
    min-height: 1em;
    font-weight: bold;
    max-height: 2.2em;
    margin-top: 1.5em;
    padding: 0.5em;
    text-transform: none;
  }

  .MuiTabs-indicator {
    background-color: none !important;
    height: 0;
  }

  .MuiTabs-scrollButtons {
    border-bottom: 1.5px solid lightgray;
    border-radius: 5px 5px 0 0;
    margin-top: 25px;

    svg {
      stroke: gray;
      fill: gray;
    }
  }

  .Mui-disabled {
    border-bottom: 1.5px solid lightgray;
    opacity: 100;
    svg {
      opacity: 0;
    }
  }

  .ah-dashboard,
  .ah-training-insights,
  .ah-recommendations {
    fill: none;
    stroke-width: 20;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }

  .ah-career-pathing,
  .ah-management,
  .ah-people,
  .ah-rules {
    fill: none;
    stroke-width: 20;
    stroke-miterlimit: 10;
  }

  .ah-content-b {
    fill: none;
    stroke-width: 6;
    stroke-miterlimit: 10;
  }

  .spacer {
    flex-grow: 500;
    margin-left: -2px;
    border-bottom: 1.5px solid lightgray;
  }
}

#admin-header.universal-header-enabled {
  min-height: 0 !important;
}

#admin-header.universal-header-enabled.plm-active {
  min-height: 84px !important;
}

#admin-dashboard h3,
#transcripts-react h3,
#ilt-calendar h3,
#dashboard h3 {
  font-size: 30px;
  font-weight: bold;
  margin: auto 0px;
  padding: 0px 0px;

  &.page-title {
    border-bottom: 2px solid;
    padding-bottom: 10px;
  }
}

#admin-dashboard h3 {
  &.page-title {
    border-bottom: none;
    padding-bottom: 0;
  }
}

#dashboard h4 {
  font-weight: bold;
}

#admin-dashboard__body {
  background-color: #f0f3f9;
  min-height: 550px;

  /* The background-color should extend to the footer. */
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 1em;
}

#dashboard-summary-donut > canvas {
  all: unset !important;
}

.assignment-status-label-container {
  display: flex;
  flex-direction: column;
  z-index: 1;
  position: absolute;
  top: 2px;
  row-gap: 1px;
  height: 100%;

  &.careerpaths {
    right: 2px;
    align-items: flex-end;
  }

  &.child {
    right: 2px;
    align-items: flex-end;
  }

  &.recommended {
    left: 2px;
    align-items: flex-start;
  }

  &.required {
    left: 2px;
    align-items: flex-start;
  }

  &.electives {
    left: 2px;
    align-items: flex-start;

    > img {
      &.duesoon {
        display: none;
      }

      &.overdue {
        display: none;
      }
    }
  }

  &.documents {
    display: none;
  }

  > img {
    &.duesoon {
      height: 20.75px;
    }

    &.overdue {
      height: 20.75px;
    }

    &.attemptsexceeded {
      height: 20.75px;
    }
  }
}

.circular-image {
  border-radius: 50%;
  height: 70px;
  width: 70px;
  min-width: 70px;
  margin-right: 1em;
  object-fit: cover;
  background-color: white;
}

.countbox-container {
  display: inline-grid;
  grid-column: 2/2;
  grid-row: 2/2;
  grid-template-columns: 19.2% 19.2% 19.2% 19.2% 19.2%;
  grid-template-rows: auto auto;
  row-gap: 10px;
  column-gap: 1%;
  width: 100%;
  height: auto;
  align-self: flex-end;
}

.countbox {
  display: block;
  background-color: white;
  max-height: 80px;
  color: black;
  width: 100%;
  height: auto;
  text-align: center;
  line-height: normal;
  box-shadow:
    0 1px 3px 0,
    0 1px 3px 0;
  word-wrap: break-word;

  .countbox-title {
    font-size: 1.15rem;
    font-weight: 500;
  }

  > .countbox-count {
    font-size: 1.5rem;
    font-weight: 900;
    margin-bottom: 2.5px;
    padding-bottom: 2.5px;
  }
}

.course-card-image-container {
  padding-top: 40%;
  position: relative;
  width: 100%;
  display: inline-block;
  z-index: 2;
}

.course-card-image-button-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 3;
  box-sizing: border-box;
}

.course-card-image-button {
  padding: 0;
  height: auto;
  border: none;

  &.full {
    opacity: 0;
    width: 100%;
  }

  &.large {
    opacity: 0;
    width: 85%;
  }

  &.small {
    opacity: 0;
    width: 100%;
    height: 65%;
  }
}

.course-card-image-button-container-right {
  display: flex;
  flex-direction: column;
  width: 15%;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;

  &.documents {
    flex-direction: column-reverse;
  }
}

.dashboard-assignment-popper {
  z-index: 7;

  ~ div.additional-filters-popup div.MuiPaper-root {
    > ul.MuiList-root {
      li {
        width: calc(100% + 20px);
      }
    }
  }
}

.dashboard-summary-container {
  display: flex;
  font-family: inherit;
  width: 93%;
  justify-content: space-evenly;
  column-gap: 4%;
}

.dashboard-breakdown-container {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  bottom: 2.5px;
}

.donut-container {
  display: flex;
  font-family: inherit;
  justify-content: center;
  align-items: center;
  width: 125px;
  height: 125px;
  position: relative;
  flex: 0 0 auto;
}

.donut-hole {
  display: flex;
  flex-direction: column;
  align-content: center;
  text-align: center;
  justify-content: center;
  font-family: inherit;
  position: absolute;
  color: black;
  background: white;
  border-radius: 50%;
  overflow: hidden;
  height: 59%;
  width: 59%;
  border-color: black;
  border: 0.1px solid black;

  > .donut-percent {
    font-size: 1.5rem;
    font-weight: 900;
  }

  > .donut-complete {
    font-size: 1.3rem;
    font-weight: 700;
    padding-bottom: 7px;
  }
}

.ellipsis-icon {
  background-color: white;
  border-radius: 53%;
  width: 100%;
  position: absolute;
  overflow: visible !important;

  &:hover {
    background-color: #e6e6e6;
  }
}

.ellipsis-menu-container {
  z-index: 7;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 15.9px;
  height: 15.9px;

  &.child {
    position: unset;
  }
}

.ellipsis-menu-button {
  background: none;
  display: flex;
  border: none;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
  justify-content: center;
  align-items: center;
}

.required-summary-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0px;
  align-self: flex-start;
  position: relative;
  bottom: 9px;
}

.sidebar-header {
  display: flex;
  align-content: center;
  column-gap: 15px;
}

.sidebar-header-info {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  max-width: 500px;
  justify-content: space-between;
}

.sidebar-header-username {
  display: inline;
  font-size: 22px;
  vertical-align: top;
  line-height: 18px;
}

.sidebar-header-userjob {
  padding: 0px 0px 0px 2px;
}

.sidebar-header-buttons {
  padding: 0px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.sidebar-profile-picture {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px white;
  border-radius: 10px;
  width: 95px;
  height: 85px;
  padding: 0.75em 0.5em;
}

.squircle-container {
  border: 1px;
  border-color: gray;
  border-style: solid;
  border-radius: 10px;
  box-shadow:
    rgba(0, 0, 0, 0.075) 0px 1px 1px inset,
    rgba(102, 175, 233, 0.6) 0px 0px 8px !important;
  padding: 0.75em 0.5em;

  &.summary {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.25em 0em 1.25em 0em;
  }

  &.widget {
    padding: 0;
    margin: 0.5em 0;
    height: 100%;
    width: 100%;

    &.gray-bottom {
      background-color: #f2f4fb;
    }
  }
}

.squircle-container--light {
  border: 1px;
  border-color: gray;
  border-style: solid;
  border-radius: 10px;
  padding: 0.75em 0.5em;
}

.squircle-container-header {
  border-radius: 10px 10px 0 0;
  margin-bottom: 0.5px;
  /* the margin-bottom: 0.5px; prevents the border-bottom from getting hidden after moving the widget. See EA-14450 */
  padding: 0.75em;
  & button {
    all: unset;
    float: right;
    font-weight: normal;
    text-decoration: underline;
  }

  &.widget {
    border-bottom: 1px solid gray;
    font-weight: 600;
    line-height: 1em;
    font-size: 16px;
  }

  .drag-icon {
    height: 16px;
    margin-bottom: -3px;
    margin-right: 0.5em;
    cursor: pointer;
  }
}

.squircle-container-body {
  border-radius: 0 0 10px 10px;
  font-family: Calibri, sans-serif;
  font-size: 14px;
  padding: 0.75em 0;

  &.widget {
    padding: 0;
  }
}

.widget {
  background-color: white;
  font-family: Calibri, sans-serif;
  font-size: 1em;
}

.widget-label {
  margin-bottom: 4px;
}

label.widget-label {
  font-weight: normal;
}

.assignments-breakdown {
  border-bottom: 1px solid #505050;
  display: flex;
  flex-direction: row;

  .filter-section {
    background-color: #f2f4fb;
    border-right: 1px solid #505050;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 0.75em;
    width: 35%;
    min-height: 100%;

    .add-filters-and-apply-buttons {
      display: flex;
      flex-direction: row;
      margin: 1.25em 0;
      max-height: 2em;
    }
  }

  button {
    height: 2em !important;
    font-size: 1em;
  }

  .date-range-input {
    min-height: 25px;
  }
}

.date-range-picker-field:focus {
  outline: 0;
}

.date-range-picker-field::placeholder {
  color: #8e8e8e;
}

.non-resizable-container {
  .box-value,
  .box-value > div {
    font-size: 25px;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 17px;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}
.widget--resize-font-to-container {
  container-name: widget--resize-font-to-container;
  container-type: inline-size;
  font-family: Calibri, sans-serif;
  font-size: 14px;

  input,
  th,
  td {
    font-family: Calibri, sans-serif;
  }

  .date-range-and-apply {
    display: flex;
    flex-direction: column;
  }

  .MuiAutocomplete-input,
  .MuiButton-root,
  .MuiInput-root,
  .MuiSelect-select {
    font-size: 14px;
  }

  .MuiInput-root {
    height: 28px;
  }

  .MuiInput-root:before {
    border-bottom: none !important;
  }

  .MuiInput-root:after {
    border-bottom: none !important;
  }

  .box-value,
  .box-value > div {
    font-size: 25px;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 17px;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width < 600px) {
  .summary-count-box {
    margin: 8px;
    padding: 20px 5px;
  }
  .box-value,
  .box-value > div {
    font-size: 23px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 16px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width < 480px) {
  .summary-count-box {
    margin: 5px;
    padding: 20px 5px;
  }
  .box-value,
  .box-value > div {
    font-size: 21px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 15px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 800px) {
  th:not(.small-widget, .full-width-widget),
  td:not(.small-widget, .full-width-widget),
  div:not(
    .box-value,
    .box-value > div,
    .box-value-for-small-widget,
    .box-value-for-small-widget > div,
    .box-label-for-full-width-widget,
    .box-label-for-full-width-widget > div,
    .box-value-for-full-width-widget,
    .box-value-for-full-width-widget > div,
    .user-logins-date-range
  ) {
    font-size: 16px !important;
  }
  .assignments-breakdown-select-dropdown::after {
    font-size: 16px !important;
  }

  .MuiAutocomplete-input,
  .MuiButton-root:not(
    .button-in-header,
    .full-width-widget,
    .user-logins-search
  ),
  .MuiInput-root:not(.user-logins-search),
  .MuiSelect-select {
    font-size: 16px !important;
  }
  .full-width-widget {
    .date-range-and-apply {
      display: flex;
      flex-direction: row;
    }
    .user-logins-date-range {
      font-size: 14px !important;
    }
  }
  .MuiInput-root:not(.small-widget) {
    height: 2em !important;
  }

  .MuiTableContainer-root &.widget--resize-font-to-container {
    overflow-x: none;
  }

  .summary-count-box {
    height: 92px;
    padding: 21px 10px;
  }
  .box-value,
  .box-value > div {
    font-size: 28px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 19px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 850px) {
  th:not(.small-widget, .full-width-widget),
  td:not(.small-widget, .full-width-widget),
  div:not(
    .box-value,
    .box-value > div,
    .box-value-for-small-widget,
    .box-value-for-small-widget > div,
    .box-label-for-full-width-widget,
    .box-label-for-full-width-widget > div,
    .box-value-for-full-width-widget,
    .box-value-for-full-width-widget > div,
    .user-logins-date-range
  ) {
    font-size: 17px !important;
  }

  .MuiButton-root:not(
    .button-in-header,
    .full-width-widget,
    .user-logins-search
  ),
  .MuiInput-root:not(.user-logins-search),
  .MuiSelect-select {
    font-size: 17px !important;
    line-height: 24px !important;
  }

  .small-widget {
    .MuiAutocomplete-input,
    .MuiSelect-select {
      line-height: 1.54em !important;
    }
  }

  .summary-count-box {
    height: 97px;
    padding: 23px 10px;
  }
  .box-value,
  .box-value > div {
    font-size: 30px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 18px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 900px) {
  th:not(.small-widget, .full-width-widget),
  td:not(.small-widget, .full-width-widget),
  div:not(
    .box-value,
    .box-value > div,
    .box-value-for-small-widget,
    .box-value-for-small-widget > div,
    .box-label-for-full-width-widget,
    .box-label-for-full-width-widget > div,
    .box-value-for-full-width-widget,
    .box-value-for-full-width-widget > div,
    .user-logins-date-range
  ) {
    font-size: 18px !important;
  }
  .MuiButton-root:not(.button-in-header, .user-logins-search),
  .MuiInput-root,
  .MuiSelect-select {
    font-size: 18px !important;
    line-height: 25px !important;
    min-height: 30px;
  }

  .search-field:not(.user-logins-search) {
    font-size: 18px !important;
  }
  .user-logins-search {
    line-height: 28px;
    min-height: 28px;
  }

  .summary-count-box {
    height: 103px;
    padding: 24px 10px;
  }
  .box-value,
  .box-value > div {
    font-size: 31px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 19px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 950px) {
  th:not(.small-widget, .full-width-widget),
  td:not(.small-widget, .full-width-widget),
  div:not(
    .box-value,
    .box-value > div,
    .box-value-for-small-widget,
    .box-value-for-small-widget > div,
    .box-label-for-full-width-widget,
    .box-label-for-full-width-widget > div,
    .box-value-for-full-width-widget,
    .box-value-for-full-width-widget > div,
    .user-logins-date-range
  ) {
    font-size: 19px !important;
  }

  .MuiButton-root:not(
    .button-in-header,
    .full-width-widget,
    .user-logins-search
  ),
  .MuiInput-root:not(.full-width-widget, .user-logins-search),
  .MuiSelect-select {
    font-size: 19px !important;
    line-height: 26px !important;
    min-height: 31px;
  }

  .MuiButton-root:not(
    .full-width-widget,
    .assignments-breakdown-apply-button,
    .search-field
  ) {
    height: 31px !important;
  }

  .summary-count-box {
    height: 109px;
    padding: 25px 10px;
  }
  .box-value,
  .box-value > div {
    font-size: 32px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 20px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 1000px) {
  th:not(.small-widget, .full-width-widget),
  td:not(.small-widget, .full-width-widget),
  div:not(
    .box-value,
    .box-value > div,
    .box-value-for-small-widget,
    .box-value-for-small-widget > div,
    .box-label-for-full-width-widget,
    .box-label-for-full-width-widget > div,
    .box-value-for-full-width-widget,
    .box-value-for-full-width-widget > div
  ) {
    font-size: 20px !important;
  }

  .MuiButton-root:not(
    .button-in-header,
    .full-width-widget,
    .user-logins-search
  ),
  .MuiInput-root:not(.user-logins-search),
  .MuiSelect-select {
    font-size: 20px !important;
    line-height: 28px !important;
    min-height: 32px;
  }

  .MuiButton-root:not(
    .full-width-widget,
    .search-field,
    .assignments-breakdown-apply-button,
    .user-logins-search
  ) {
    height: 32px !important;
  }

  .MuiInput-root:not(.full-width-widget, .user-logins-search) {
    height: 2em !important;
  }
  .full-width-widget {
    .user-logins-date-range {
      font-size: initial !important;
    }
  }
  .summary-count-box {
    height: 115px;
    padding: 27px 10px;
  }
  .box-value,
  .box-value > div {
    font-size: 33px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label {
    font-size: 21px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

.small-widget {
  display: flex;
  flex-direction: column;
  font-family: Calibri, sans-serif;
  justify-content: space-around;
  min-height: 100%;

  .upper-section {
    padding: 0.5em 0.75em;
  }
  .lower-section {
    background-color: #f2f4fb;
    border-top: 1px solid darkgray;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    width: 100%;
  }
  .widget-label {
    font-size: 1em;
  }
  .MuiSelect-select {
    font-size: 1em !important;
    padding-left: 4px !important;
  }
  .date-range-picker-field {
    padding-left: 4px !important;
    font-size: 14px;
  }
  .search-field {
    font-size: 14px;
    height: 28px;
    max-height: 28px;
  }
  .search-dropdown {
    font-size: 14px;
    .MuiFormControl-root {
      margin: 0 !important;
    }
    .MuiOutlinedInput-root {
      border-radius: 3px;
      height: 25px;
      padding: 3px 0 0 5px !important;
    }
    .MuiInputLabel-root {
      font-size: 1em;
    }
    .MuiInputBase-input {
      padding: 0;
    }

    fieldset {
      height: 25px;
      line-height: 25px;
      font-family: Calibri, sans-serif;
      font-size: 14px;
    }

    .MuiInputLabel-root {
      font-family: Calibri, sans-serif !important;
      transform: translate(10px, 4px) scale(1);
    }
    .MuiInputLabel-shrink {
      transform: translate(11px, -8px) scale(0.85);
    }
  }

  svg {
    right: 0;
  }
}

.full-width-widget {
  font-family: Calibri, sans-serif;
  .upper-section {
    padding: 0.5em 0.75em;
  }
  .widget-label {
    font-size: 1em;
  }
  .MuiSelect-select {
    font-size: 1em !important;
    padding-left: 4px !important;
  }
  .date-range-picker-field {
    padding-left: 4px !important;
    font-size: 14px;
  }
  .search-dropdown {
    font-size: 14px;
    .MuiFormControl-root {
      margin: 0 !important;
    }
    .MuiOutlinedInput-root {
      border-radius: 3px;
      height: 25px;
      padding: 3px 0 0 5px !important;
    }
    .MuiInputLabel-root {
      font-size: 1em;
    }
    .MuiInputBase-input {
      padding: 0;
    }

    fieldset {
      height: 25px;
      line-height: 25px;
      font-family: Calibri, sans-serif;
      font-size: 14px;
    }

    .MuiInputLabel-root {
      font-family: Calibri, sans-serif !important;
      transform: translate(10px, 4px) scale(1);
    }
  }

  svg {
    right: 0;
  }
}

.MuiAutocomplete-option {
  font-family: Calibri, sans-serif !important;
  height: 25px;
  line-height: 25px;
  padding: 0 6px !important;
  white-space: nowrap;
  &:hover {
    background-color: #fafbff !important;
  }
}

.MuiAutocomplete-popper > div {
  border-radius: 3px;
  border: 1px solid black !important;
}

.MuiAutocomplete-popper {
  ul {
    scrollbar-width: thin;
  }
}

.MuiMenuItem-root:hover,
.MuiAutocomplete-option[aria-selected='true'] {
  background-color: #fafbff !important;
}

.MuiAutocomplete-input {
  font-size: 1em;
}

.MuiAutocomplete-input,
.MuiAutocomplete-option,
.MuiAutocomplete-noOptions {
  font-family: Calibri, sans-serif;
  font-size: 14px;
}

.MuiAutocomplete-paper {
  margin-top: 8px;
  min-width: 100%;
  width: fit-content;
}

.MuiAutocomplete-listbox {
  padding: 0;
  max-height: 200px !important;
}

.MuiAutocomplete-noOptions {
  padding: 8px !important;
}

.summary-count-box-for-small-widget {
  margin: 5px;
  padding: 20px 0px;
}
.box-value-for-small-widget,
.box-value-for-small-widget > div {
  font-size: 21px !important;
  font-weight: bold;
  line-height: 1em;
}
.box-label-for-small-widget {
  font-size: 15px !important;
  line-height: 1em;
  display: inline-block;
  vertical-align: middle;
}

.admin-dashboard-button,
.admin-dashboard-button--disabled {
  &.widget-label {
    height: 1.79em;
  }
}

@container widget--resize-font-to-container (width > 240px) {
  .lower-section {
    padding-top: 15px;
  }
  .summary-count-box-for-small-widget {
    margin: 8px;
    padding: 20px 0px;
  }
  .small-widget {
    .MuiAutocomplete-input,
    .MuiAutocomplete-option,
    .MuiSelect-select {
      font-family: Calibri, sans-serif;
      line-height: 1.69em;
    }

    .search-dropdown {
      .MuiInputLabel-root {
        transform: translate(10px, 3px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(11px, -10px) scale(0.85);
      }
    }
  }

  .box-value-for-small-widget,
  .box-value-for-small-widget > div {
    font-size: 23px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-small-widget {
    font-size: 16px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 300px) {
  .admin-dashboard-button,
  .admin-dashboard-button--disabled {
    &.widget-label {
      height: 2em;
    }
  }
  .lower-section {
    padding-top: 12px;
  }
  .small-widget {
    .date-range-picker-field,
    .search-dropdown,
    .widget-label {
      font-family: Calibri, sans-serif;
      font-size: 14px !important;
    }
    .MuiButton-root {
      height: 25px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 14px;
      }

      .MuiInputLabel-root {
        transform: translate(10px, 3px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(9px, -10px) scale(0.84);
      }
    }
  }
  .box-value-for-small-widget,
  .box-value-for-small-widget > div {
    font-size: 25px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-small-widget {
    font-size: 17px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 350px) {
  .small-widget {
    .search-dropdown {
      .MuiInputLabel-shrink {
        transform: translate(10px, -10px) scale(0.84);
      }
    }
  }
}

@container widget--resize-font-to-container (width > 400px) {
  .small-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .widget-label:not(.search-field) {
      font-size: 16px !important;
    }
    .MuiAutocomplete-input,
    .MuiAutocomplete-option,
    .MuiFormControl-root > div > div,
    .MuiSelect-select {
      line-height: 1.55em;
    }
    .MuiFormControl-root > div > div {
      min-height: 26.5px;
    }
    .widget-label::after {
      font-size: 16px !important;
    }
    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 16px;
      }

      .MuiInputLabel-root {
        transform: translate(10px, 1px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(10px, -11px) scale(0.75);
        padding-right: 2px;
      }
    }
  }
  .summary-count-box-for-small-widget {
    padding: 21px 10px;
  }
  .box-value-for-small-widget,
  .box-value-for-small-widget > div {
    font-size: 28px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-small-widget {
    font-size: 19px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 425px) {
  .lower-section {
    padding-top: 10px;
  }
  .small-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .widget-label:not(.search-field) {
      font-size: 17px !important;
    }
    .MuiAutocomplete-input,
    .MuiButton-root:not(.widget-label) {
      height: 29px;
    }
    .MuiButton-root {
      &.widget-label:not(.user-logins-search) {
        height: 28px !important;
      }
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 17px;
      }
      .MuiInputLabel-root {
        transform: translate(10px, 1px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(10px, -11px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 28px !important;
        font-size: 16px !important;
      }
      .MuiOutlinedInput-root {
        padding: 0 0 0 5px !important;
      }
    }
  }

  .summary-count-box-for-small-widget {
    padding: 23px 10px;
  }
  .box-value-for-small-widget,
  .box-value-for-small-widget > div {
    font-size: 30px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-small-widget {
    font-size: 18px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 450px) {
  .lower-section {
    padding-top: 8px;
  }
  .small-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .widget-label:not(.search-field) {
      font-size: 18px !important;
    }
    .MuiAutocomplete-input,
    .MuiAutocomplete-option,
    .MuiFormControl-root > div > div,
    .MuiSelect-select {
      line-height: 1.54em;
    }
    .MuiFormControl-root > div > div {
      min-height: 29.5px;
    }
    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 18px;
      }
      .MuiInputLabel-root {
        font-size: 19px !important;
        transform: translate(10px, 0px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(10px, -13px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 34px !important;
        font-size: 18px !important;
      }
    }
  }

  .summary-count-box-for-small-widget {
    padding: 24px 10px;
  }
  .box-value-for-small-widget,
  .box-value-for-small-widget > div {
    font-size: 31px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-small-widget {
    font-size: 19px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 475px) {
  .lower-section {
    padding-top: 5px;
  }
  .small-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .widget-label:not(.search-field) {
      font-size: 19x !important;
    }
    .MuiButton-root:not(.user-logins-search) {
      height: 29px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 19px;
      }
      .MuiInputLabel-root {
        transform: translate(10px, 0px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(12px, -13px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 34px !important;
        font-size: 18px !important;
      }
    }
  }

  .summary-count-box-for-small-widget {
    padding: 25px 10px;
  }
  .box-value-for-small-widget,
  .box-value-for-small-widget > div {
    font-size: 32px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-small-widget {
    font-size: 20px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 500px) {
  .lower-section {
    padding-top: 0px;
  }
  .small-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .widget-label:not(.search-field) {
      font-size: 20px !important;
    }
    .MuiAutocomplete-input,
    .MuiButton-root:not(.user-logins-search) {
      height: 32px;
    }
    .MuiButton-root:not(.user-logins-search) {
      &.widget-label {
        height: 32px !important;
      }
    }
    .MuiOutlinedInput-notchedOutline {
      height: 40px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 20px !important;
      }
      .MuiSvgIcon-root,
      .MuiAutocomplete-input {
        margin: 2px 0 -2px 0;
      }
      .MuiInputLabel-root {
        font-size: 20px !important;
        transform: translate(10px, 0px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(12px, -14px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 37px !important;
        font-size: 19px !important;
      }
      .MuiIconButton-root {
        height: 32px;
      }
    }
  }

  .summary-count-box-for-small-widget {
    padding: 27px 10px;
  }
  .box-value-for-small-widget,
  .box-value-for-small-widget > div {
    font-size: 33px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-small-widget {
    font-size: 21px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

.box-value-for-full-width-widget,
.box-value-for-full-width-widget > div {
  font-size: 23px;
  font-weight: bold;
  line-height: 1em;
}
.box-label-for-full-width-widget {
  font-size: 16px;
  line-height: 1em;
  display: inline-block;
  vertical-align: middle;
}

@container widget--resize-font-to-container (width > 960px) {
  .summary-count-box-for-full-width-widget {
    margin: 8px;
    padding: 20px 0px;
  }
  .full-width-widget {
    .MuiAutocomplete-input,
    .MuiAutocomplete-option,
    .MuiSelect-select {
      font-family: Calibri, sans-serif;
      line-height: 1.69em;
    }

    .search-dropdown {
      .MuiInputLabel-root {
        transform: translate(10px, 3px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(11px, -10px) scale(0.85);
      }
    }
  }

  .box-value-for-full-width-widget,
  .box-value-for-full-width-widget > div {
    font-size: 27px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-full-width-widget {
    font-size: 18px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 1200px) {
  .admin-dashboard-button,
  .admin-dashboard-button--disabled {
    &.widget-label {
      height: 2em;
    }
  }
  .full-width-widget {
    .date-range-picker-field,
    .search-field,
    .search-dropdown,
    .widget-label {
      font-family: Calibri, sans-serif;
      font-size: 14px !important;
    }
    .MuiButton-root {
      height: 25px;
    }
    .search-field {
      height: 28px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 14px;
      }

      .MuiInputLabel-root {
        transform: translate(10px, 3px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(11px, -10px) scale(0.85);
      }
    }
  }
  .box-value-for-full-width-widget,
  .box-value-for-full-width-widget > div {
    font-size: 29px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-full-width-widget {
    font-size: 19px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 1600px) {
  .full-width-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .user-logins-search,
    .widget-label {
      font-size: 16px !important;
    }
    .MuiAutocomplete-input,
    .MuiAutocomplete-option,
    .MuiSelect-select {
      line-height: 1.55em;
    }

    .user-logins-search,
    .search-field {
      height: 29px;
      max-height: 29px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 16px;
      }

      .MuiInputLabel-root {
        transform: translate(10px, 1px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(10px, -11px) scale(0.75);
        padding-right: 2px;
      }
    }
  }
  .summary-count-box-for-full-width-widget {
    padding: 21px 10px;
  }
  .box-value-for-full-width-widget,
  .box-value-for-full-width-widget > div {
    font-size: 32px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-full-width-widget {
    font-size: 20px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 1700px) {
  .full-width-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .user-logins-search,
    .widget-label {
      font-size: 17px !important;
    }
    .MuiAutocomplete-input,
    .MuiButton-root {
      height: 29px;
    }

    .user-logins-search,
    .search-field {
      height: 30px;
      max-height: 30px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 17px;
      }
      .MuiInputLabel-root {
        transform: translate(10px, 1px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(10px, -11px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 28px !important;
        font-size: 16px !important;
      }
      .MuiOutlinedInput-root {
        padding: 0 0 0 5px !important;
      }
    }
  }

  .summary-count-box-for-full-width-widget {
    padding: 23px 10px;
  }
  .box-value-for-full-width-widget,
  .box-value-for-full-width-widget > div {
    font-size: 34px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-full-width-widget {
    font-size: 20px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 1800px) {
  .full-width-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .user-logins-search,
    .widget-label {
      font-size: 18px !important;
    }
    .MuiAutocomplete-input,
    .MuiAutocomplete-option,
    .MuiSelect-select {
      line-height: 1.54em;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 18px;
      }
      .MuiInputLabel-root {
        font-size: 19px !important;
        transform: translate(10px, 0px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(10px, -13px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 34px !important;
        font-size: 18px !important;
      }
    }
  }

  .summary-count-box-for-full-width-widget {
    padding: 24px 10px;
  }
  .box-value-for-full-width-widget,
  .box-value-for-full-width-widget > div {
    font-size: 35px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-full-width-widget {
    font-size: 21px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 1900px) {
  /* .lower-section {
    padding-top: 5px;
  } */
  .full-width-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .user-logins-search,
    .widget-label {
      font-size: 19x !important;
    }
    .MuiButton-root {
      height: 29px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 19px;
      }
      .MuiInputLabel-root {
        transform: translate(10px, 0px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(12px, -13px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 34px !important;
        font-size: 18px !important;
      }
    }
  }

  .summary-count-box-for-full-width-widget {
    padding: 25px 10px;
  }
  .box-value-for-full-width-widget,
  .box-value-for-full-width-widget > div {
    font-size: 36px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-full-width-widget {
    font-size: 22px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

@container widget--resize-font-to-container (width > 2000px) {
  /* .lower-section {
    padding-top: 0px;
  } */
  .full-width-widget {
    th,
    td,
    .date-range-picker-field,
    .search-dropdown,
    .user-logins-search,
    .widget-label {
      font-size: 20px !important;
    }
    .MuiAutocomplete-input,
    .MuiButton-root {
      height: 32px;
    }
    .search-field {
      height: 32px;
      max-height: 32px;
    }

    .MuiOutlinedInput-notchedOutline {
      height: 40px;
    }

    .search-dropdown {
      .MuiAutocomplete-input,
      .MuiAutocomplete-option {
        font-size: 20px !important;
      }
      .MuiInputLabel-root {
        font-size: 20px !important;
        transform: translate(10px, 0px) scale(1);
      }
      .MuiInputLabel-shrink {
        transform: translate(12px, -14px) scale(0.75);
      }
      .MuiOutlinedInput-notchedOutline {
        height: 37px !important;
        font-size: 19px !important;
      }
      .MuiIconButton-root {
        height: 32px;
      }
    }
  }

  .summary-count-box-for-full-width-widget {
    padding: 27px 10px;
  }
  .box-value-for-full-width-widget,
  .box-value-for-full-width-widget > div {
    font-size: 37px !important;
    font-weight: bold;
    line-height: 1em;
  }
  .box-label-for-full-width-widget {
    font-size: 23px !important;
    line-height: 1em;
    display: inline-block;
    vertical-align: middle;
  }
}

.additional-filters-button {
  border: 1px solid black;
  border-radius: 3px;
  height: 2em;
  margin-right: 1em;
  width: 2em;
}

.additional-filters-body {
  > .MuiFormControl-root {
    > .widget-label {
      margin-top: 5px;
    }
  }
  .widget-label {
    margin-top: 5px;
  }
  > .button-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 14px 0 5px 0;
  }

  > .react-dropdown-tree-select {
    font-family: Calibri, sans-serif;
    height: auto;
    min-height: 25px;
    margin-bottom: 0.25em;

    .tree {
      background-color: white;
      width: 20em;
    }

    .checkbox-item {
      margin-bottom: 6px;
      margin-right: 0.5em;
    }

    .node-label {
      font-weight: normal;
    }
    .search {
      border-bottom: none;
      padding: 0 0.5em;
    }

    .dropdown-trigger {
      height: 25px;
      border: 1px solid black;
      border-radius: 3px;
      margin: 0;
      overflow: hidden;
      padding: 0;
      top: 0;
      width: 327px;
      cursor: pointer;
    }

    a.dropdown-trigger:focus {
      outline: none !important;
    }

    .tag-item {
      margin: 0 0.5em;
      font-size: 14px;
      line-height: 1.4375em;
    }

    .tag-item:has(> .tag) {
      height: 0;
      display: none;
    }

    .dropdown-trigger.arrow > ul {
      margin: 0 0.5em;
      font-size: 14px;
      width: 288px;
      line-height: 1.4375em;
      color: black !important;
      padding-top: 2px;
      > .tag-list {
        width: 288px;
        > .tag-item {
          width: 288px;
          > .placeholder {
            width: 288px;
          }
        }
      }
    }

    .tag-list > .tag-item {
      padding-top: 2px;
      width: 273px;
    }

    .dropdown-trigger.arrow.bottom:after,
    .dropdown-trigger.arrow.top:after {
      display: inline-block;
      -webkit-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
      -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      font-size: 1.5rem;
      position: absolute;
      pointer-events: none;
      margin-right: 3em;
    }

    .dropdown-trigger.arrow.bottom:after {
      content: '\\1F783';
    }

    .dropdown-trigger.arrow.top:after {
      content: '\\1F781';
      top: 0.35em;
    }

    .dropdown-content {
      top: 22px;
      border: 1px solid black;
      border-radius: 0 0 4px 4px;
      width: 327px;
    }

    .tag-item > .search {
      margin: 0;
      height: 22px;
      width: 288px;
      ::focus {
        outline: none;
        pointer-events: none;
      }
    }

    input:focus {
      outline: none;
    }

    .toggle.expanded {
      margin-left: 4px;
      margin-right: 2.5px;
    }

    .tag-item > .search:focus,
    .search:hover {
      outline: none;
      cursor: pointer;
    }

    .dropdown-content > .search {
      display: none;
    }

    label {
      pointer-events: visible;

      > input {
        cursor: pointer;
        pointer-events: visible;
      }
    }

    &.action-tooltips li.node i[title] {
      display: block;
      position: relative;
      height: 100%;
      width: 150px;
      top: -25px;
      left: 30px;
    }
  }

  .dropdown-title-and-clear {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > .clear-button {
      background: white;
      border: none;
      color: red;
      padding: 0;
      padding-top: 2px;
    }
  }
}

.admin-dashboard-button,
.admin-dashboard-button--disabled {
  border-radius: 5px !important;
  height: 2em;
  font-family: Calibri, sans-serif !important;
  width: calc(100% - 3em);
  padding: 0 10px !important;
}

.admin-dashboard-button--disabled {
  border-color: #808080;
  color: #929292;
}

.assignments-breakdown-table {
  border-spacing: 0;
  td {
    width: 0.1%;
    white-space: nowrap;
  }
}

.email-modal {
  &.MuiFormControl-root {
    margin: 0 !important;
  }
}

.infinite-scroll-component {
  max-height: 20em;
  padding-bottom: 6px;
  overflow: hidden;
  padding-top: 6px;
  > .node {
    height: 1.8em;
    > i {
      font-style: normal;
      margin: 0 2px;
    }
  }
}

.resource-popup {
  > th {
    font-family: Calibri, sans-serif !important;
  }
  > td {
    font-family: Calibri, sans-serif !important;
  }
}

.basic-button {
  border: 1px solid black;
  border-radius: 8px;
  font-size: 1.6rem;
  padding: 0 1em;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.75;
  white-space: nowrap;

  &.white {
    background-color: #fff;
    color: #000;

    &.width-button {
      min-width: 158px;
    }
  }

  &.themed {
    background-color: #1eabe3;
    color: #fff;
  }

  &.small {
    max-width: 100px;
  }

  &.medium {
    max-width: 150px;
  }

  &.right-margin {
    margin-right: 10px;
  }
}

.cert-link {
  font-size: 1em !important;
  text-decoration: revert !important;
}

.text-align-right-inherit-padding {
  text-align: right;
  padding: inherit;
}

.text-align-right-no-padding {
  text-align: right;
  padding: 0px 0px !important;
}

.sidebar-icon-rows {
  display: flex;
  flex-direction: column;

  > .help-center {
    height: 56px !important;

    > div > a {
      font-size: 14px !important;
    }

    > div > a > div {
      height: inherit;
      margin: 17px 0px 0px 60px !important;
    }
  }
}

.sidebar-icon-row {
  height: 40px;
  padding: 0 !important;
  margin-bottom: 3px;
  display: flex;
  justify-content: space-between;

  > div {
    padding: inherit;

    > a > svg {
      padding-left: 1px !important;
      padding-right: 0;
    }
  }
}

#dashboard-footer {
  text-align: center;
  margin: 3.75em 0 0 0;
  background-color: #e8e8e8;
  box-shadow: unset !important;
  justify-content: center;

  & .dashboard-footer-text {
    margin: 1em 0 !important;
  }

  & .footer-button-container {
    flex: 6;
    display: flex;
    gap: 10px;
    justify-content: center;
    margin: 1.3em 0 0.75em 0 !important;

    & button {
      padding: 8px 12px;
      text-transform: capitalize;

      > img {
        width: 24px !important;
        height: 24px !important;
        margin-right: 4px;
      }
    }
  }
}

.section-header-container {
  display: flex;
  margin: 0 0;
  flex-direction: row-reverse;
  justify-content: space-between;

  & h4 {
    margin-right: auto;
  }

  .section-nav-links {
    margin-top: 5px !important;

    .svgIcon {
      height: 14px;
      margin: 0 10px;
      vertical-align: middle;
      stroke: #000 !important;
    }

    & a {
      text-underline-offset: 3px;
      padding-bottom: 0px;
      margin-bottom: 0px;
    }

    & a:hover {
      color: #000;
    }

    & a:nth-of-type(1) {
      margin-right: 20px;
    }

    & a:nth-last-of-type(1) {
      margin-right: 10px;
    }
  }
}

@media screen and (max-width: 1200px) {
  .countbox {
    > .countbox-title {
      font-size: 0.9vw;
    }

    > .countbox-count {
      font-size: 1.3vw;
    }
  }
}

/*#region MUI Menu Customizations*/

.ellipsis-menu {
  > .MuiMenu-paper {
    border: 1px solid #a4a4a4;
    background-color: #f4f4f4;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 3px;
    margin-top: 4px;
    > .MuiMenu-list {
      padding: 0px;

      > .MuiMenuItem-root {
        padding: 3px;
        justify-content: center;
        align-items: center;
        width: 55px;
        height: auto;
        font-size: 12px;
        color: #444444;
        line-height: normal;
      }
    }
  }
}
/*#endregion*/

.childcourse-container {
  background-color: white;
  color: black;
  display: grid;
  margin: 2em 0;
  grid-template-columns:
    [checkmark-col] 2em [image-col] calc(33.333% - 2em + 5px)
    [text-col] auto;
  /* the width of the image-col is 33% - 2em (from the checkmark-col) + 5px which is a third of the marginRight -15px that the CP has.
  This way the right side of the child image lines up with the right side of the CP image */
}

.childcourse-item {
  background-color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin-right: 0.97em;
}

.cc-checkmark-image-wrapper {
  grid-column: 1 / span 2;
  grid-row: 2 / span 2;
}

.cc-checkmark-image-combined {
  grid-column: 1 / span 2;
  grid-row: 2;
  display: grid;
  margin: 0;
  grid-template-columns: [cc-checkmark-col] 2em [cc-image-col] auto;
  align-content: center;
  justify-items: center;
}

.cc-image-only {
  margin-left: 0.5em;
}

.cc-checkmark-col {
  grid-column: 1;
  grid-row: 2;
  padding-top: 2.5em;
  align-content: stretch;
}

@media screen and (min-width: 1300px) {
  .cc-checkmark-col {
    padding-top: 3em;
  }
}

@media screen and (min-width: 1500px) {
  .cc-checkmark-col {
    padding-top: 4em;
  }
}

@media screen and (min-width: 1800px) {
  .cc-checkmark-col {
    padding-top: 5em;
  }
}

.cc-checkmark-img {
  height: 1em;
  width: 1em;
}

.cc-image-cell {
  grid-column: 2;
  grid-row: 2 / span 2;
  height: 0;
  padding-bottom: 39.4%;
}

.cc-date-cell {
  grid-column: 2;
  grid-row: 1;
}

.cc-text-cell {
  grid-column: 3;
  grid-row: 2;
  margin-left: 1em;
}

.cc-button-cell {
  display: grid;
  grid-column: 3;
  grid-row: 3;
  align-items: end;
  margin-left: 1em;
}

.cc-button-container {
  display: flex;
  flex-direction: row;

  & button {
    margin-right: 10px;
  }
}

.alert-component {
  > .MuiAlert-icon {
    padding: 9px 0;
  }
}

.recommended-content-container {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;;;;;EAKE,gCAAgC;EAChC,gBAAgB;EAChB;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,+GAA+G;EAC/G,iBAAiB;EACjB,YAAY;;EAEZ;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;;EAEjB;IACE,SAAS;IACT,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IACjC,SAAS;EACX;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;IAC1B,gBAAgB;;IAEhB;MACE,YAAY;MACZ,UAAU;IACZ;EACF;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ;MACE,UAAU;IACZ;EACF;;EAEA;;;IAGE,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;;;;IAIE,UAAU;IACV,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,oCAAoC;EACtC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAIE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,wBAAwB;IACxB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;;EAEjB,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;;EAEZ;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,uBAAuB;;IAEvB;MACE;QACE,aAAa;MACf;;MAEA;QACE,aAAa;MACf;IACF;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,oDAAoD;EACpD,6BAA6B;EAC7B,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB;;eAEa;EACb,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;;EAEZ;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,UAAU;;EAEV;IACE;MACE;QACE,wBAAwB;MAC1B;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,yBAAyB;;EAEzB;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;;EAE5B;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;;EAEd;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB;;mDAEiD;EACjD,qBAAqB;;EAErB;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,eAAe;IACf,YAAY;IACZ,WAAW;;IAEX;MACE,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,mHAAmH;EACnH,eAAe;EACf;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;;EAEjB;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;;EAEnB;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;IACf,UAAU;IACV,gBAAgB;;IAEhB;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;;EAEf;;;IAGE,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;;;;;;;;;IAaE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA;;;;;;;;IAQE,0BAA0B;EAC5B;EACA;IACE;MACE,aAAa;MACb,mBAAmB;IACrB;IACA;MACE,0BAA0B;IAC5B;EACF;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;;;;;;;;;IAaE,0BAA0B;EAC5B;;EAEA;;;;;;;IAOE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE;;MAEE,8BAA8B;IAChC;EACF;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;;;;;;;;;IAaE,0BAA0B;EAC5B;EACA;;;IAGE,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;;;;;;;;;IAaE,0BAA0B;EAC5B;;EAEA;;;;;;;IAOE,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;;;;;IAKE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;;;;;;;;IAYE,0BAA0B;EAC5B;;EAEA;;;;;;;IAOE,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;;;;;;IAME,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE;MACE,6BAA6B;IAC/B;EACF;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;;EAEhB;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,eAAe;IACf;MACE,oBAAoB;IACtB;IACA;MACE,kBAAkB;MAClB,YAAY;MACZ,+BAA+B;IACjC;IACA;MACE,cAAc;IAChB;IACA;MACE,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,iBAAiB;MACjB,gCAAgC;MAChC,eAAe;IACjB;;IAEA;MACE,2CAA2C;MAC3C,wCAAwC;IAC1C;IACA;MACE,4CAA4C;IAC9C;EACF;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,gCAAgC;EAChC;IACE,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,eAAe;EACjB;EACA;IACE,eAAe;IACf;MACE,oBAAoB;IACtB;IACA;MACE,kBAAkB;MAClB,YAAY;MACZ,+BAA+B;IACjC;IACA;MACE,cAAc;IAChB;IACA;MACE,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,iBAAiB;MACjB,gCAAgC;MAChC,eAAe;IACjB;;IAEA;MACE,2CAA2C;MAC3C,wCAAwC;IAC1C;EACF;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE;;;MAGE,gCAAgC;MAChC,mBAAmB;IACrB;;IAEA;MACE;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;IACF;EACF;;EAEA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE;MACE,WAAW;IACb;EACF;EACA;IACE,iBAAiB;EACnB;EACA;IACE;;;MAGE,gCAAgC;MAChC,0BAA0B;IAC5B;IACA;MACE,YAAY;IACd;;IAEA;MACE;;QAEE,eAAe;MACjB;;MAEA;QACE,wCAAwC;MAC1C;MACA;QACE,4CAA4C;MAC9C;IACF;EACF;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE;MACE;QACE,6CAA6C;MAC/C;IACF;EACF;AACF;;AAEA;EACE;IACE;;;;;MAKE,0BAA0B;IAC5B;IACA;;;;MAIE,mBAAmB;IACrB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,0BAA0B;IAC5B;IACA;MACE;;QAEE,eAAe;MACjB;;MAEA;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;QAC7C,kBAAkB;MACpB;IACF;EACF;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE;;;;;MAKE,0BAA0B;IAC5B;IACA;;MAEE,YAAY;IACd;IACA;MACE;QACE,uBAAuB;MACzB;IACF;;IAEA;MACE;;QAEE,eAAe;MACjB;MACA;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;MACA;QACE,6BAA6B;MAC/B;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE;;;;;MAKE,0BAA0B;IAC5B;IACA;;;;MAIE,mBAAmB;IACrB;IACA;MACE,kBAAkB;IACpB;IACA;MACE;;QAEE,eAAe;MACjB;MACA;QACE,0BAA0B;QAC1B,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE;;;;;MAKE,yBAAyB;IAC3B;IACA;MACE,YAAY;IACd;;IAEA;MACE;;QAEE,eAAe;MACjB;MACA;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE;;;;;MAKE,0BAA0B;IAC5B;IACA;;MAEE,YAAY;IACd;IACA;MACE;QACE,uBAAuB;MACzB;IACF;IACA;MACE,YAAY;IACd;;IAEA;MACE;;QAEE,0BAA0B;MAC5B;MACA;;QAEE,oBAAoB;MACtB;MACA;QACE,0BAA0B;QAC1B,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;MACA;QACE,YAAY;MACd;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE;;;MAGE,gCAAgC;MAChC,mBAAmB;IACrB;;IAEA;MACE;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;IACF;EACF;;EAEA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE;MACE,WAAW;IACb;EACF;EACA;IACE;;;;MAIE,gCAAgC;MAChC,0BAA0B;IAC5B;IACA;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;;IAEA;MACE;;QAEE,eAAe;MACjB;;MAEA;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;IACF;EACF;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE;;;;;;MAME,0BAA0B;IAC5B;IACA;;;MAGE,mBAAmB;IACrB;;IAEA;;MAEE,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE;;QAEE,eAAe;MACjB;;MAEA;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;QAC7C,kBAAkB;MACpB;IACF;EACF;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE;;;;;;MAME,0BAA0B;IAC5B;IACA;;MAEE,YAAY;IACd;;IAEA;;MAEE,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE;;QAEE,eAAe;MACjB;MACA;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;MACA;QACE,6BAA6B;MAC/B;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE;;;;;;MAME,0BAA0B;IAC5B;IACA;;;MAGE,mBAAmB;IACrB;;IAEA;MACE;;QAEE,eAAe;MACjB;MACA;QACE,0BAA0B;QAC1B,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;KAEG;EACH;IACE;;;;;;MAME,yBAAyB;IAC3B;IACA;MACE,YAAY;IACd;;IAEA;MACE;;QAEE,eAAe;MACjB;MACA;QACE,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;;KAEG;EACH;IACE;;;;;;MAME,0BAA0B;IAC5B;IACA;;MAEE,YAAY;IACd;IACA;MACE,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE;;QAEE,0BAA0B;MAC5B;MACA;QACE,0BAA0B;QAC1B,wCAAwC;MAC1C;MACA;QACE,6CAA6C;MAC/C;MACA;QACE,uBAAuB;QACvB,0BAA0B;MAC5B;MACA;QACE,YAAY;MACd;IACF;EACF;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;;IAErB;MACE,uBAAuB;MACvB,WAAW;IACb;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,YAAY;MACZ,uBAAuB;MACvB,kBAAkB;MAClB,SAAS;MACT,gBAAgB;MAChB,UAAU;MACV,MAAM;MACN,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,eAAe;MACf,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,SAAS;MACT,aAAa;IACf;;IAEA;MACE,eAAe;MACf,eAAe;MACf,YAAY;MACZ,qBAAqB;MACrB,uBAAuB;MACvB,gBAAgB;MAChB;QACE,YAAY;QACZ;UACE,YAAY;UACZ;YACE,YAAY;UACd;QACF;MACF;IACF;;IAEA;MACE,gBAAgB;MAChB,YAAY;IACd;;IAEA;;MAEE,qBAAqB;MACrB,sBAAsB;MACtB,oBAAoB;MACpB,cAAc;MACd,+DAA+D;MAC/D,uDAAuD;MACvD,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,WAAW;IACb;;IAEA;MACE,SAAS;MACT,uBAAuB;MACvB,0BAA0B;MAC1B,YAAY;IACd;;IAEA;MACE,SAAS;MACT,YAAY;MACZ,YAAY;MACZ;QACE,aAAa;QACb,oBAAoB;MACtB;IACF;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;;MAEE,aAAa;MACb,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,uBAAuB;;MAEvB;QACE,eAAe;QACf,uBAAuB;MACzB;IACF;;IAEA;MACE,cAAc;MACd,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,UAAU;MACV,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;MACE,iBAAiB;MACjB,YAAY;MACZ,UAAU;MACV,UAAU;MACV,gBAAgB;IAClB;EACF;AACF;;AAEA;;EAEE,6BAA6B;EAC7B,WAAW;EACX,2CAA2C;EAC3C,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB;IACE,aAAa;IACb;MACE,kBAAkB;MAClB,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,WAAW;;IAEX;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB;IACE,uBAAuB;;IAEvB;MACE,0BAA0B;IAC5B;;IAEA;MACE,eAAe;MACf,oCAAoC;IACtC;EACF;AACF;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;;EAE9B;IACE,gBAAgB;;IAEhB;MACE,4BAA4B;MAC5B,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;;EAEvB;IACE,wBAAwB;EAC1B;;EAEA;IACE,OAAO;IACP,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mCAAmC;;IAEnC;MACE,iBAAiB;MACjB,0BAA0B;;MAE1B;QACE,sBAAsB;QACtB,uBAAuB;QACvB,iBAAiB;MACnB;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;;EAE9B;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;;IAE1B;MACE,YAAY;MACZ,cAAc;MACd,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,0BAA0B;MAC1B,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA,kCAAkC;;AAElC;EACE;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;MACE,YAAY;;MAEZ;QACE,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,eAAe;QACf,cAAc;QACd,mBAAmB;MACrB;IACF;EACF;AACF;AACA,aAAa;;AAEb;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb;;mBAEiB;EACjB;2FACyF;AAC3F;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,SAAS;EACT,iEAAiE;EACjE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;AACb","sourcesContent":["#admin-dashboard,\n#admin-header,\n#transcripts-react,\n#ilt-calendar,\n#dashboard {\n  font-family: Calibri, sans-serif;\n  font-size: 1.4em;\n  .main-section {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n}\n\n#admin-dashboard {\n  /* Setting min-height in order to force the footer to be below the dashboard. Also see #admin-dashboard__body */\n  min-height: 500px;\n  width: 100vw;\n\n  .react-grid-item.react-grid-placeholder {\n    background: #1eabe3;\n  }\n\n  .react-resizable-handle-se {\n    margin-bottom: -2px;\n    margin-right: 5px;\n  }\n\n  .page-title-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n\n#admin-header {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  min-height: 100px;\n\n  .hamburger-container {\n    bottom: 0;\n    border-bottom: 1.5px solid lightgray;\n    padding: 0.5em 1em;\n    width: 3em;\n  }\n\n  .admin-logo-container {\n    border-bottom: 1.5px solid lightgray;\n    padding-bottom: 0.5em;\n    padding-top: 0.5em;\n  }\n\n  &.universal-header-enabled .admin-logo-container {\n    display: none !important;\n  }\n\n  &.universal-header-enabled .hamburger-container {\n    width: 5em !important;\n  }\n\n  .tab {\n    border-radius: 5px 5px 0 0;\n    font-family: Calibri, sans-serif;\n    font-size: 16px;\n    min-height: 1em;\n    font-weight: bold;\n    max-height: 2.2em;\n    margin-top: 1.5em;\n    padding: 0.5em;\n    text-transform: none;\n  }\n\n  .MuiTabs-indicator {\n    background-color: none !important;\n    height: 0;\n  }\n\n  .MuiTabs-scrollButtons {\n    border-bottom: 1.5px solid lightgray;\n    border-radius: 5px 5px 0 0;\n    margin-top: 25px;\n\n    svg {\n      stroke: gray;\n      fill: gray;\n    }\n  }\n\n  .Mui-disabled {\n    border-bottom: 1.5px solid lightgray;\n    opacity: 100;\n    svg {\n      opacity: 0;\n    }\n  }\n\n  .ah-dashboard,\n  .ah-training-insights,\n  .ah-recommendations {\n    fill: none;\n    stroke-width: 20;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 10;\n  }\n\n  .ah-career-pathing,\n  .ah-management,\n  .ah-people,\n  .ah-rules {\n    fill: none;\n    stroke-width: 20;\n    stroke-miterlimit: 10;\n  }\n\n  .ah-content-b {\n    fill: none;\n    stroke-width: 6;\n    stroke-miterlimit: 10;\n  }\n\n  .spacer {\n    flex-grow: 500;\n    margin-left: -2px;\n    border-bottom: 1.5px solid lightgray;\n  }\n}\n\n#admin-header.universal-header-enabled {\n  min-height: 0 !important;\n}\n\n#admin-header.universal-header-enabled.plm-active {\n  min-height: 84px !important;\n}\n\n#admin-dashboard h3,\n#transcripts-react h3,\n#ilt-calendar h3,\n#dashboard h3 {\n  font-size: 30px;\n  font-weight: bold;\n  margin: auto 0px;\n  padding: 0px 0px;\n\n  &.page-title {\n    border-bottom: 2px solid;\n    padding-bottom: 10px;\n  }\n}\n\n#admin-dashboard h3 {\n  &.page-title {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n}\n\n#dashboard h4 {\n  font-weight: bold;\n}\n\n#admin-dashboard__body {\n  background-color: #f0f3f9;\n  min-height: 550px;\n\n  /* The background-color should extend to the footer. */\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 1em;\n}\n\n#dashboard-summary-donut > canvas {\n  all: unset !important;\n}\n\n.assignment-status-label-container {\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  position: absolute;\n  top: 2px;\n  row-gap: 1px;\n  height: 100%;\n\n  &.careerpaths {\n    right: 2px;\n    align-items: flex-end;\n  }\n\n  &.child {\n    right: 2px;\n    align-items: flex-end;\n  }\n\n  &.recommended {\n    left: 2px;\n    align-items: flex-start;\n  }\n\n  &.required {\n    left: 2px;\n    align-items: flex-start;\n  }\n\n  &.electives {\n    left: 2px;\n    align-items: flex-start;\n\n    > img {\n      &.duesoon {\n        display: none;\n      }\n\n      &.overdue {\n        display: none;\n      }\n    }\n  }\n\n  &.documents {\n    display: none;\n  }\n\n  > img {\n    &.duesoon {\n      height: 20.75px;\n    }\n\n    &.overdue {\n      height: 20.75px;\n    }\n\n    &.attemptsexceeded {\n      height: 20.75px;\n    }\n  }\n}\n\n.circular-image {\n  border-radius: 50%;\n  height: 70px;\n  width: 70px;\n  min-width: 70px;\n  margin-right: 1em;\n  object-fit: cover;\n  background-color: white;\n}\n\n.countbox-container {\n  display: inline-grid;\n  grid-column: 2/2;\n  grid-row: 2/2;\n  grid-template-columns: 19.2% 19.2% 19.2% 19.2% 19.2%;\n  grid-template-rows: auto auto;\n  row-gap: 10px;\n  column-gap: 1%;\n  width: 100%;\n  height: auto;\n  align-self: flex-end;\n}\n\n.countbox {\n  display: block;\n  background-color: white;\n  max-height: 80px;\n  color: black;\n  width: 100%;\n  height: auto;\n  text-align: center;\n  line-height: normal;\n  box-shadow:\n    0 1px 3px 0,\n    0 1px 3px 0;\n  word-wrap: break-word;\n\n  .countbox-title {\n    font-size: 1.15rem;\n    font-weight: 500;\n  }\n\n  > .countbox-count {\n    font-size: 1.5rem;\n    font-weight: 900;\n    margin-bottom: 2.5px;\n    padding-bottom: 2.5px;\n  }\n}\n\n.course-card-image-container {\n  padding-top: 40%;\n  position: relative;\n  width: 100%;\n  display: inline-block;\n  z-index: 2;\n}\n\n.course-card-image-button-container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 3;\n  box-sizing: border-box;\n}\n\n.course-card-image-button {\n  padding: 0;\n  height: auto;\n  border: none;\n\n  &.full {\n    opacity: 0;\n    width: 100%;\n  }\n\n  &.large {\n    opacity: 0;\n    width: 85%;\n  }\n\n  &.small {\n    opacity: 0;\n    width: 100%;\n    height: 65%;\n  }\n}\n\n.course-card-image-button-container-right {\n  display: flex;\n  flex-direction: column;\n  width: 15%;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n\n  &.documents {\n    flex-direction: column-reverse;\n  }\n}\n\n.dashboard-assignment-popper {\n  z-index: 7;\n\n  ~ div.additional-filters-popup div.MuiPaper-root {\n    > ul.MuiList-root {\n      li {\n        width: calc(100% + 20px);\n      }\n    }\n  }\n}\n\n.dashboard-summary-container {\n  display: flex;\n  font-family: inherit;\n  width: 93%;\n  justify-content: space-evenly;\n  column-gap: 4%;\n}\n\n.dashboard-breakdown-container {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  bottom: 2.5px;\n}\n\n.donut-container {\n  display: flex;\n  font-family: inherit;\n  justify-content: center;\n  align-items: center;\n  width: 125px;\n  height: 125px;\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.donut-hole {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  text-align: center;\n  justify-content: center;\n  font-family: inherit;\n  position: absolute;\n  color: black;\n  background: white;\n  border-radius: 50%;\n  overflow: hidden;\n  height: 59%;\n  width: 59%;\n  border-color: black;\n  border: 0.1px solid black;\n\n  > .donut-percent {\n    font-size: 1.5rem;\n    font-weight: 900;\n  }\n\n  > .donut-complete {\n    font-size: 1.3rem;\n    font-weight: 700;\n    padding-bottom: 7px;\n  }\n}\n\n.ellipsis-icon {\n  background-color: white;\n  border-radius: 53%;\n  width: 100%;\n  position: absolute;\n  overflow: visible !important;\n\n  &:hover {\n    background-color: #e6e6e6;\n  }\n}\n\n.ellipsis-menu-container {\n  z-index: 7;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 15.9px;\n  height: 15.9px;\n\n  &.child {\n    position: unset;\n  }\n}\n\n.ellipsis-menu-button {\n  background: none;\n  display: flex;\n  border: none;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 0;\n  justify-content: center;\n  align-items: center;\n}\n\n.required-summary-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  margin: 0px;\n  align-self: flex-start;\n  position: relative;\n  bottom: 9px;\n}\n\n.sidebar-header {\n  display: flex;\n  align-content: center;\n  column-gap: 15px;\n}\n\n.sidebar-header-info {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  width: 100%;\n  max-width: 500px;\n  justify-content: space-between;\n}\n\n.sidebar-header-username {\n  display: inline;\n  font-size: 22px;\n  vertical-align: top;\n  line-height: 18px;\n}\n\n.sidebar-header-userjob {\n  padding: 0px 0px 0px 2px;\n}\n\n.sidebar-header-buttons {\n  padding: 0px !important;\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.sidebar-profile-picture {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  border: 1px white;\n  border-radius: 10px;\n  width: 95px;\n  height: 85px;\n  padding: 0.75em 0.5em;\n}\n\n.squircle-container {\n  border: 1px;\n  border-color: gray;\n  border-style: solid;\n  border-radius: 10px;\n  box-shadow:\n    rgba(0, 0, 0, 0.075) 0px 1px 1px inset,\n    rgba(102, 175, 233, 0.6) 0px 0px 8px !important;\n  padding: 0.75em 0.5em;\n\n  &.summary {\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1.25em 0em 1.25em 0em;\n  }\n\n  &.widget {\n    padding: 0;\n    margin: 0.5em 0;\n    height: 100%;\n    width: 100%;\n\n    &.gray-bottom {\n      background-color: #f2f4fb;\n    }\n  }\n}\n\n.squircle-container--light {\n  border: 1px;\n  border-color: gray;\n  border-style: solid;\n  border-radius: 10px;\n  padding: 0.75em 0.5em;\n}\n\n.squircle-container-header {\n  border-radius: 10px 10px 0 0;\n  margin-bottom: 0.5px;\n  /* the margin-bottom: 0.5px; prevents the border-bottom from getting hidden after moving the widget. See EA-14450 */\n  padding: 0.75em;\n  & button {\n    all: unset;\n    float: right;\n    font-weight: normal;\n    text-decoration: underline;\n  }\n\n  &.widget {\n    border-bottom: 1px solid gray;\n    font-weight: 600;\n    line-height: 1em;\n    font-size: 16px;\n  }\n\n  .drag-icon {\n    height: 16px;\n    margin-bottom: -3px;\n    margin-right: 0.5em;\n    cursor: pointer;\n  }\n}\n\n.squircle-container-body {\n  border-radius: 0 0 10px 10px;\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n  padding: 0.75em 0;\n\n  &.widget {\n    padding: 0;\n  }\n}\n\n.widget {\n  background-color: white;\n  font-family: Calibri, sans-serif;\n  font-size: 1em;\n}\n\n.widget-label {\n  margin-bottom: 4px;\n}\n\nlabel.widget-label {\n  font-weight: normal;\n}\n\n.assignments-breakdown {\n  border-bottom: 1px solid #505050;\n  display: flex;\n  flex-direction: row;\n\n  .filter-section {\n    background-color: #f2f4fb;\n    border-right: 1px solid #505050;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding: 0.75em;\n    width: 35%;\n    min-height: 100%;\n\n    .add-filters-and-apply-buttons {\n      display: flex;\n      flex-direction: row;\n      margin: 1.25em 0;\n      max-height: 2em;\n    }\n  }\n\n  button {\n    height: 2em !important;\n    font-size: 1em;\n  }\n\n  .date-range-input {\n    min-height: 25px;\n  }\n}\n\n.date-range-picker-field:focus {\n  outline: 0;\n}\n\n.date-range-picker-field::placeholder {\n  color: #8e8e8e;\n}\n\n.non-resizable-container {\n  .box-value,\n  .box-value > div {\n    font-size: 25px;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 17px;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n.widget--resize-font-to-container {\n  container-name: widget--resize-font-to-container;\n  container-type: inline-size;\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n\n  input,\n  th,\n  td {\n    font-family: Calibri, sans-serif;\n  }\n\n  .date-range-and-apply {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .MuiAutocomplete-input,\n  .MuiButton-root,\n  .MuiInput-root,\n  .MuiSelect-select {\n    font-size: 14px;\n  }\n\n  .MuiInput-root {\n    height: 28px;\n  }\n\n  .MuiInput-root:before {\n    border-bottom: none !important;\n  }\n\n  .MuiInput-root:after {\n    border-bottom: none !important;\n  }\n\n  .box-value,\n  .box-value > div {\n    font-size: 25px;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 17px;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width < 600px) {\n  .summary-count-box {\n    margin: 8px;\n    padding: 20px 5px;\n  }\n  .box-value,\n  .box-value > div {\n    font-size: 23px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 16px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width < 480px) {\n  .summary-count-box {\n    margin: 5px;\n    padding: 20px 5px;\n  }\n  .box-value,\n  .box-value > div {\n    font-size: 21px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 15px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 800px) {\n  th:not(.small-widget, .full-width-widget),\n  td:not(.small-widget, .full-width-widget),\n  div:not(\n    .box-value,\n    .box-value > div,\n    .box-value-for-small-widget,\n    .box-value-for-small-widget > div,\n    .box-label-for-full-width-widget,\n    .box-label-for-full-width-widget > div,\n    .box-value-for-full-width-widget,\n    .box-value-for-full-width-widget > div,\n    .user-logins-date-range\n  ) {\n    font-size: 16px !important;\n  }\n  .assignments-breakdown-select-dropdown::after {\n    font-size: 16px !important;\n  }\n\n  .MuiAutocomplete-input,\n  .MuiButton-root:not(\n    .button-in-header,\n    .full-width-widget,\n    .user-logins-search\n  ),\n  .MuiInput-root:not(.user-logins-search),\n  .MuiSelect-select {\n    font-size: 16px !important;\n  }\n  .full-width-widget {\n    .date-range-and-apply {\n      display: flex;\n      flex-direction: row;\n    }\n    .user-logins-date-range {\n      font-size: 14px !important;\n    }\n  }\n  .MuiInput-root:not(.small-widget) {\n    height: 2em !important;\n  }\n\n  .MuiTableContainer-root &.widget--resize-font-to-container {\n    overflow-x: none;\n  }\n\n  .summary-count-box {\n    height: 92px;\n    padding: 21px 10px;\n  }\n  .box-value,\n  .box-value > div {\n    font-size: 28px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 19px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 850px) {\n  th:not(.small-widget, .full-width-widget),\n  td:not(.small-widget, .full-width-widget),\n  div:not(\n    .box-value,\n    .box-value > div,\n    .box-value-for-small-widget,\n    .box-value-for-small-widget > div,\n    .box-label-for-full-width-widget,\n    .box-label-for-full-width-widget > div,\n    .box-value-for-full-width-widget,\n    .box-value-for-full-width-widget > div,\n    .user-logins-date-range\n  ) {\n    font-size: 17px !important;\n  }\n\n  .MuiButton-root:not(\n    .button-in-header,\n    .full-width-widget,\n    .user-logins-search\n  ),\n  .MuiInput-root:not(.user-logins-search),\n  .MuiSelect-select {\n    font-size: 17px !important;\n    line-height: 24px !important;\n  }\n\n  .small-widget {\n    .MuiAutocomplete-input,\n    .MuiSelect-select {\n      line-height: 1.54em !important;\n    }\n  }\n\n  .summary-count-box {\n    height: 97px;\n    padding: 23px 10px;\n  }\n  .box-value,\n  .box-value > div {\n    font-size: 30px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 18px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 900px) {\n  th:not(.small-widget, .full-width-widget),\n  td:not(.small-widget, .full-width-widget),\n  div:not(\n    .box-value,\n    .box-value > div,\n    .box-value-for-small-widget,\n    .box-value-for-small-widget > div,\n    .box-label-for-full-width-widget,\n    .box-label-for-full-width-widget > div,\n    .box-value-for-full-width-widget,\n    .box-value-for-full-width-widget > div,\n    .user-logins-date-range\n  ) {\n    font-size: 18px !important;\n  }\n  .MuiButton-root:not(.button-in-header, .user-logins-search),\n  .MuiInput-root,\n  .MuiSelect-select {\n    font-size: 18px !important;\n    line-height: 25px !important;\n    min-height: 30px;\n  }\n\n  .search-field:not(.user-logins-search) {\n    font-size: 18px !important;\n  }\n  .user-logins-search {\n    line-height: 28px;\n    min-height: 28px;\n  }\n\n  .summary-count-box {\n    height: 103px;\n    padding: 24px 10px;\n  }\n  .box-value,\n  .box-value > div {\n    font-size: 31px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 19px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 950px) {\n  th:not(.small-widget, .full-width-widget),\n  td:not(.small-widget, .full-width-widget),\n  div:not(\n    .box-value,\n    .box-value > div,\n    .box-value-for-small-widget,\n    .box-value-for-small-widget > div,\n    .box-label-for-full-width-widget,\n    .box-label-for-full-width-widget > div,\n    .box-value-for-full-width-widget,\n    .box-value-for-full-width-widget > div,\n    .user-logins-date-range\n  ) {\n    font-size: 19px !important;\n  }\n\n  .MuiButton-root:not(\n    .button-in-header,\n    .full-width-widget,\n    .user-logins-search\n  ),\n  .MuiInput-root:not(.full-width-widget, .user-logins-search),\n  .MuiSelect-select {\n    font-size: 19px !important;\n    line-height: 26px !important;\n    min-height: 31px;\n  }\n\n  .MuiButton-root:not(\n    .full-width-widget,\n    .assignments-breakdown-apply-button,\n    .search-field\n  ) {\n    height: 31px !important;\n  }\n\n  .summary-count-box {\n    height: 109px;\n    padding: 25px 10px;\n  }\n  .box-value,\n  .box-value > div {\n    font-size: 32px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 20px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 1000px) {\n  th:not(.small-widget, .full-width-widget),\n  td:not(.small-widget, .full-width-widget),\n  div:not(\n    .box-value,\n    .box-value > div,\n    .box-value-for-small-widget,\n    .box-value-for-small-widget > div,\n    .box-label-for-full-width-widget,\n    .box-label-for-full-width-widget > div,\n    .box-value-for-full-width-widget,\n    .box-value-for-full-width-widget > div\n  ) {\n    font-size: 20px !important;\n  }\n\n  .MuiButton-root:not(\n    .button-in-header,\n    .full-width-widget,\n    .user-logins-search\n  ),\n  .MuiInput-root:not(.user-logins-search),\n  .MuiSelect-select {\n    font-size: 20px !important;\n    line-height: 28px !important;\n    min-height: 32px;\n  }\n\n  .MuiButton-root:not(\n    .full-width-widget,\n    .search-field,\n    .assignments-breakdown-apply-button,\n    .user-logins-search\n  ) {\n    height: 32px !important;\n  }\n\n  .MuiInput-root:not(.full-width-widget, .user-logins-search) {\n    height: 2em !important;\n  }\n  .full-width-widget {\n    .user-logins-date-range {\n      font-size: initial !important;\n    }\n  }\n  .summary-count-box {\n    height: 115px;\n    padding: 27px 10px;\n  }\n  .box-value,\n  .box-value > div {\n    font-size: 33px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label {\n    font-size: 21px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n.small-widget {\n  display: flex;\n  flex-direction: column;\n  font-family: Calibri, sans-serif;\n  justify-content: space-around;\n  min-height: 100%;\n\n  .upper-section {\n    padding: 0.5em 0.75em;\n  }\n  .lower-section {\n    background-color: #f2f4fb;\n    border-top: 1px solid darkgray;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    width: 100%;\n  }\n  .widget-label {\n    font-size: 1em;\n  }\n  .MuiSelect-select {\n    font-size: 1em !important;\n    padding-left: 4px !important;\n  }\n  .date-range-picker-field {\n    padding-left: 4px !important;\n    font-size: 14px;\n  }\n  .search-field {\n    font-size: 14px;\n    height: 28px;\n    max-height: 28px;\n  }\n  .search-dropdown {\n    font-size: 14px;\n    .MuiFormControl-root {\n      margin: 0 !important;\n    }\n    .MuiOutlinedInput-root {\n      border-radius: 3px;\n      height: 25px;\n      padding: 3px 0 0 5px !important;\n    }\n    .MuiInputLabel-root {\n      font-size: 1em;\n    }\n    .MuiInputBase-input {\n      padding: 0;\n    }\n\n    fieldset {\n      height: 25px;\n      line-height: 25px;\n      font-family: Calibri, sans-serif;\n      font-size: 14px;\n    }\n\n    .MuiInputLabel-root {\n      font-family: Calibri, sans-serif !important;\n      transform: translate(10px, 4px) scale(1);\n    }\n    .MuiInputLabel-shrink {\n      transform: translate(11px, -8px) scale(0.85);\n    }\n  }\n\n  svg {\n    right: 0;\n  }\n}\n\n.full-width-widget {\n  font-family: Calibri, sans-serif;\n  .upper-section {\n    padding: 0.5em 0.75em;\n  }\n  .widget-label {\n    font-size: 1em;\n  }\n  .MuiSelect-select {\n    font-size: 1em !important;\n    padding-left: 4px !important;\n  }\n  .date-range-picker-field {\n    padding-left: 4px !important;\n    font-size: 14px;\n  }\n  .search-dropdown {\n    font-size: 14px;\n    .MuiFormControl-root {\n      margin: 0 !important;\n    }\n    .MuiOutlinedInput-root {\n      border-radius: 3px;\n      height: 25px;\n      padding: 3px 0 0 5px !important;\n    }\n    .MuiInputLabel-root {\n      font-size: 1em;\n    }\n    .MuiInputBase-input {\n      padding: 0;\n    }\n\n    fieldset {\n      height: 25px;\n      line-height: 25px;\n      font-family: Calibri, sans-serif;\n      font-size: 14px;\n    }\n\n    .MuiInputLabel-root {\n      font-family: Calibri, sans-serif !important;\n      transform: translate(10px, 4px) scale(1);\n    }\n  }\n\n  svg {\n    right: 0;\n  }\n}\n\n.MuiAutocomplete-option {\n  font-family: Calibri, sans-serif !important;\n  height: 25px;\n  line-height: 25px;\n  padding: 0 6px !important;\n  white-space: nowrap;\n  &:hover {\n    background-color: #fafbff !important;\n  }\n}\n\n.MuiAutocomplete-popper > div {\n  border-radius: 3px;\n  border: 1px solid black !important;\n}\n\n.MuiAutocomplete-popper {\n  ul {\n    scrollbar-width: thin;\n  }\n}\n\n.MuiMenuItem-root:hover,\n.MuiAutocomplete-option[aria-selected='true'] {\n  background-color: #fafbff !important;\n}\n\n.MuiAutocomplete-input {\n  font-size: 1em;\n}\n\n.MuiAutocomplete-input,\n.MuiAutocomplete-option,\n.MuiAutocomplete-noOptions {\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n}\n\n.MuiAutocomplete-paper {\n  margin-top: 8px;\n  min-width: 100%;\n  width: fit-content;\n}\n\n.MuiAutocomplete-listbox {\n  padding: 0;\n  max-height: 200px !important;\n}\n\n.MuiAutocomplete-noOptions {\n  padding: 8px !important;\n}\n\n.summary-count-box-for-small-widget {\n  margin: 5px;\n  padding: 20px 0px;\n}\n.box-value-for-small-widget,\n.box-value-for-small-widget > div {\n  font-size: 21px !important;\n  font-weight: bold;\n  line-height: 1em;\n}\n.box-label-for-small-widget {\n  font-size: 15px !important;\n  line-height: 1em;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.admin-dashboard-button,\n.admin-dashboard-button--disabled {\n  &.widget-label {\n    height: 1.79em;\n  }\n}\n\n@container widget--resize-font-to-container (width > 240px) {\n  .lower-section {\n    padding-top: 15px;\n  }\n  .summary-count-box-for-small-widget {\n    margin: 8px;\n    padding: 20px 0px;\n  }\n  .small-widget {\n    .MuiAutocomplete-input,\n    .MuiAutocomplete-option,\n    .MuiSelect-select {\n      font-family: Calibri, sans-serif;\n      line-height: 1.69em;\n    }\n\n    .search-dropdown {\n      .MuiInputLabel-root {\n        transform: translate(10px, 3px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(11px, -10px) scale(0.85);\n      }\n    }\n  }\n\n  .box-value-for-small-widget,\n  .box-value-for-small-widget > div {\n    font-size: 23px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-small-widget {\n    font-size: 16px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 300px) {\n  .admin-dashboard-button,\n  .admin-dashboard-button--disabled {\n    &.widget-label {\n      height: 2em;\n    }\n  }\n  .lower-section {\n    padding-top: 12px;\n  }\n  .small-widget {\n    .date-range-picker-field,\n    .search-dropdown,\n    .widget-label {\n      font-family: Calibri, sans-serif;\n      font-size: 14px !important;\n    }\n    .MuiButton-root {\n      height: 25px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 14px;\n      }\n\n      .MuiInputLabel-root {\n        transform: translate(10px, 3px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(9px, -10px) scale(0.84);\n      }\n    }\n  }\n  .box-value-for-small-widget,\n  .box-value-for-small-widget > div {\n    font-size: 25px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-small-widget {\n    font-size: 17px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 350px) {\n  .small-widget {\n    .search-dropdown {\n      .MuiInputLabel-shrink {\n        transform: translate(10px, -10px) scale(0.84);\n      }\n    }\n  }\n}\n\n@container widget--resize-font-to-container (width > 400px) {\n  .small-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .widget-label:not(.search-field) {\n      font-size: 16px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiAutocomplete-option,\n    .MuiFormControl-root > div > div,\n    .MuiSelect-select {\n      line-height: 1.55em;\n    }\n    .MuiFormControl-root > div > div {\n      min-height: 26.5px;\n    }\n    .widget-label::after {\n      font-size: 16px !important;\n    }\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 16px;\n      }\n\n      .MuiInputLabel-root {\n        transform: translate(10px, 1px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(10px, -11px) scale(0.75);\n        padding-right: 2px;\n      }\n    }\n  }\n  .summary-count-box-for-small-widget {\n    padding: 21px 10px;\n  }\n  .box-value-for-small-widget,\n  .box-value-for-small-widget > div {\n    font-size: 28px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-small-widget {\n    font-size: 19px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 425px) {\n  .lower-section {\n    padding-top: 10px;\n  }\n  .small-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .widget-label:not(.search-field) {\n      font-size: 17px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiButton-root:not(.widget-label) {\n      height: 29px;\n    }\n    .MuiButton-root {\n      &.widget-label:not(.user-logins-search) {\n        height: 28px !important;\n      }\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 17px;\n      }\n      .MuiInputLabel-root {\n        transform: translate(10px, 1px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(10px, -11px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 28px !important;\n        font-size: 16px !important;\n      }\n      .MuiOutlinedInput-root {\n        padding: 0 0 0 5px !important;\n      }\n    }\n  }\n\n  .summary-count-box-for-small-widget {\n    padding: 23px 10px;\n  }\n  .box-value-for-small-widget,\n  .box-value-for-small-widget > div {\n    font-size: 30px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-small-widget {\n    font-size: 18px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 450px) {\n  .lower-section {\n    padding-top: 8px;\n  }\n  .small-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .widget-label:not(.search-field) {\n      font-size: 18px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiAutocomplete-option,\n    .MuiFormControl-root > div > div,\n    .MuiSelect-select {\n      line-height: 1.54em;\n    }\n    .MuiFormControl-root > div > div {\n      min-height: 29.5px;\n    }\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 18px;\n      }\n      .MuiInputLabel-root {\n        font-size: 19px !important;\n        transform: translate(10px, 0px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(10px, -13px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 34px !important;\n        font-size: 18px !important;\n      }\n    }\n  }\n\n  .summary-count-box-for-small-widget {\n    padding: 24px 10px;\n  }\n  .box-value-for-small-widget,\n  .box-value-for-small-widget > div {\n    font-size: 31px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-small-widget {\n    font-size: 19px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 475px) {\n  .lower-section {\n    padding-top: 5px;\n  }\n  .small-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .widget-label:not(.search-field) {\n      font-size: 19x !important;\n    }\n    .MuiButton-root:not(.user-logins-search) {\n      height: 29px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 19px;\n      }\n      .MuiInputLabel-root {\n        transform: translate(10px, 0px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(12px, -13px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 34px !important;\n        font-size: 18px !important;\n      }\n    }\n  }\n\n  .summary-count-box-for-small-widget {\n    padding: 25px 10px;\n  }\n  .box-value-for-small-widget,\n  .box-value-for-small-widget > div {\n    font-size: 32px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-small-widget {\n    font-size: 20px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 500px) {\n  .lower-section {\n    padding-top: 0px;\n  }\n  .small-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .widget-label:not(.search-field) {\n      font-size: 20px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiButton-root:not(.user-logins-search) {\n      height: 32px;\n    }\n    .MuiButton-root:not(.user-logins-search) {\n      &.widget-label {\n        height: 32px !important;\n      }\n    }\n    .MuiOutlinedInput-notchedOutline {\n      height: 40px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 20px !important;\n      }\n      .MuiSvgIcon-root,\n      .MuiAutocomplete-input {\n        margin: 2px 0 -2px 0;\n      }\n      .MuiInputLabel-root {\n        font-size: 20px !important;\n        transform: translate(10px, 0px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(12px, -14px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 37px !important;\n        font-size: 19px !important;\n      }\n      .MuiIconButton-root {\n        height: 32px;\n      }\n    }\n  }\n\n  .summary-count-box-for-small-widget {\n    padding: 27px 10px;\n  }\n  .box-value-for-small-widget,\n  .box-value-for-small-widget > div {\n    font-size: 33px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-small-widget {\n    font-size: 21px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n.box-value-for-full-width-widget,\n.box-value-for-full-width-widget > div {\n  font-size: 23px;\n  font-weight: bold;\n  line-height: 1em;\n}\n.box-label-for-full-width-widget {\n  font-size: 16px;\n  line-height: 1em;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n@container widget--resize-font-to-container (width > 960px) {\n  .summary-count-box-for-full-width-widget {\n    margin: 8px;\n    padding: 20px 0px;\n  }\n  .full-width-widget {\n    .MuiAutocomplete-input,\n    .MuiAutocomplete-option,\n    .MuiSelect-select {\n      font-family: Calibri, sans-serif;\n      line-height: 1.69em;\n    }\n\n    .search-dropdown {\n      .MuiInputLabel-root {\n        transform: translate(10px, 3px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(11px, -10px) scale(0.85);\n      }\n    }\n  }\n\n  .box-value-for-full-width-widget,\n  .box-value-for-full-width-widget > div {\n    font-size: 27px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-full-width-widget {\n    font-size: 18px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 1200px) {\n  .admin-dashboard-button,\n  .admin-dashboard-button--disabled {\n    &.widget-label {\n      height: 2em;\n    }\n  }\n  .full-width-widget {\n    .date-range-picker-field,\n    .search-field,\n    .search-dropdown,\n    .widget-label {\n      font-family: Calibri, sans-serif;\n      font-size: 14px !important;\n    }\n    .MuiButton-root {\n      height: 25px;\n    }\n    .search-field {\n      height: 28px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 14px;\n      }\n\n      .MuiInputLabel-root {\n        transform: translate(10px, 3px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(11px, -10px) scale(0.85);\n      }\n    }\n  }\n  .box-value-for-full-width-widget,\n  .box-value-for-full-width-widget > div {\n    font-size: 29px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-full-width-widget {\n    font-size: 19px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 1600px) {\n  .full-width-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .user-logins-search,\n    .widget-label {\n      font-size: 16px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiAutocomplete-option,\n    .MuiSelect-select {\n      line-height: 1.55em;\n    }\n\n    .user-logins-search,\n    .search-field {\n      height: 29px;\n      max-height: 29px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 16px;\n      }\n\n      .MuiInputLabel-root {\n        transform: translate(10px, 1px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(10px, -11px) scale(0.75);\n        padding-right: 2px;\n      }\n    }\n  }\n  .summary-count-box-for-full-width-widget {\n    padding: 21px 10px;\n  }\n  .box-value-for-full-width-widget,\n  .box-value-for-full-width-widget > div {\n    font-size: 32px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-full-width-widget {\n    font-size: 20px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 1700px) {\n  .full-width-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .user-logins-search,\n    .widget-label {\n      font-size: 17px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiButton-root {\n      height: 29px;\n    }\n\n    .user-logins-search,\n    .search-field {\n      height: 30px;\n      max-height: 30px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 17px;\n      }\n      .MuiInputLabel-root {\n        transform: translate(10px, 1px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(10px, -11px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 28px !important;\n        font-size: 16px !important;\n      }\n      .MuiOutlinedInput-root {\n        padding: 0 0 0 5px !important;\n      }\n    }\n  }\n\n  .summary-count-box-for-full-width-widget {\n    padding: 23px 10px;\n  }\n  .box-value-for-full-width-widget,\n  .box-value-for-full-width-widget > div {\n    font-size: 34px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-full-width-widget {\n    font-size: 20px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 1800px) {\n  .full-width-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .user-logins-search,\n    .widget-label {\n      font-size: 18px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiAutocomplete-option,\n    .MuiSelect-select {\n      line-height: 1.54em;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 18px;\n      }\n      .MuiInputLabel-root {\n        font-size: 19px !important;\n        transform: translate(10px, 0px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(10px, -13px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 34px !important;\n        font-size: 18px !important;\n      }\n    }\n  }\n\n  .summary-count-box-for-full-width-widget {\n    padding: 24px 10px;\n  }\n  .box-value-for-full-width-widget,\n  .box-value-for-full-width-widget > div {\n    font-size: 35px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-full-width-widget {\n    font-size: 21px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 1900px) {\n  /* .lower-section {\n    padding-top: 5px;\n  } */\n  .full-width-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .user-logins-search,\n    .widget-label {\n      font-size: 19x !important;\n    }\n    .MuiButton-root {\n      height: 29px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 19px;\n      }\n      .MuiInputLabel-root {\n        transform: translate(10px, 0px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(12px, -13px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 34px !important;\n        font-size: 18px !important;\n      }\n    }\n  }\n\n  .summary-count-box-for-full-width-widget {\n    padding: 25px 10px;\n  }\n  .box-value-for-full-width-widget,\n  .box-value-for-full-width-widget > div {\n    font-size: 36px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-full-width-widget {\n    font-size: 22px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n@container widget--resize-font-to-container (width > 2000px) {\n  /* .lower-section {\n    padding-top: 0px;\n  } */\n  .full-width-widget {\n    th,\n    td,\n    .date-range-picker-field,\n    .search-dropdown,\n    .user-logins-search,\n    .widget-label {\n      font-size: 20px !important;\n    }\n    .MuiAutocomplete-input,\n    .MuiButton-root {\n      height: 32px;\n    }\n    .search-field {\n      height: 32px;\n      max-height: 32px;\n    }\n\n    .MuiOutlinedInput-notchedOutline {\n      height: 40px;\n    }\n\n    .search-dropdown {\n      .MuiAutocomplete-input,\n      .MuiAutocomplete-option {\n        font-size: 20px !important;\n      }\n      .MuiInputLabel-root {\n        font-size: 20px !important;\n        transform: translate(10px, 0px) scale(1);\n      }\n      .MuiInputLabel-shrink {\n        transform: translate(12px, -14px) scale(0.75);\n      }\n      .MuiOutlinedInput-notchedOutline {\n        height: 37px !important;\n        font-size: 19px !important;\n      }\n      .MuiIconButton-root {\n        height: 32px;\n      }\n    }\n  }\n\n  .summary-count-box-for-full-width-widget {\n    padding: 27px 10px;\n  }\n  .box-value-for-full-width-widget,\n  .box-value-for-full-width-widget > div {\n    font-size: 37px !important;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  .box-label-for-full-width-widget {\n    font-size: 23px !important;\n    line-height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n.additional-filters-button {\n  border: 1px solid black;\n  border-radius: 3px;\n  height: 2em;\n  margin-right: 1em;\n  width: 2em;\n}\n\n.additional-filters-body {\n  > .MuiFormControl-root {\n    > .widget-label {\n      margin-top: 5px;\n    }\n  }\n  .widget-label {\n    margin-top: 5px;\n  }\n  > .button-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 14px 0 5px 0;\n  }\n\n  > .react-dropdown-tree-select {\n    font-family: Calibri, sans-serif;\n    height: auto;\n    min-height: 25px;\n    margin-bottom: 0.25em;\n\n    .tree {\n      background-color: white;\n      width: 20em;\n    }\n\n    .checkbox-item {\n      margin-bottom: 6px;\n      margin-right: 0.5em;\n    }\n\n    .node-label {\n      font-weight: normal;\n    }\n    .search {\n      border-bottom: none;\n      padding: 0 0.5em;\n    }\n\n    .dropdown-trigger {\n      height: 25px;\n      border: 1px solid black;\n      border-radius: 3px;\n      margin: 0;\n      overflow: hidden;\n      padding: 0;\n      top: 0;\n      width: 327px;\n      cursor: pointer;\n    }\n\n    a.dropdown-trigger:focus {\n      outline: none !important;\n    }\n\n    .tag-item {\n      margin: 0 0.5em;\n      font-size: 14px;\n      line-height: 1.4375em;\n    }\n\n    .tag-item:has(> .tag) {\n      height: 0;\n      display: none;\n    }\n\n    .dropdown-trigger.arrow > ul {\n      margin: 0 0.5em;\n      font-size: 14px;\n      width: 288px;\n      line-height: 1.4375em;\n      color: black !important;\n      padding-top: 2px;\n      > .tag-list {\n        width: 288px;\n        > .tag-item {\n          width: 288px;\n          > .placeholder {\n            width: 288px;\n          }\n        }\n      }\n    }\n\n    .tag-list > .tag-item {\n      padding-top: 2px;\n      width: 273px;\n    }\n\n    .dropdown-trigger.arrow.bottom:after,\n    .dropdown-trigger.arrow.top:after {\n      display: inline-block;\n      -webkit-flex-shrink: 0;\n      -ms-flex-negative: 0;\n      flex-shrink: 0;\n      -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      font-size: 1.5rem;\n      position: absolute;\n      pointer-events: none;\n      margin-right: 3em;\n    }\n\n    .dropdown-trigger.arrow.bottom:after {\n      content: '\\1F783';\n    }\n\n    .dropdown-trigger.arrow.top:after {\n      content: '\\1F781';\n      top: 0.35em;\n    }\n\n    .dropdown-content {\n      top: 22px;\n      border: 1px solid black;\n      border-radius: 0 0 4px 4px;\n      width: 327px;\n    }\n\n    .tag-item > .search {\n      margin: 0;\n      height: 22px;\n      width: 288px;\n      ::focus {\n        outline: none;\n        pointer-events: none;\n      }\n    }\n\n    input:focus {\n      outline: none;\n    }\n\n    .toggle.expanded {\n      margin-left: 4px;\n      margin-right: 2.5px;\n    }\n\n    .tag-item > .search:focus,\n    .search:hover {\n      outline: none;\n      cursor: pointer;\n    }\n\n    .dropdown-content > .search {\n      display: none;\n    }\n\n    label {\n      pointer-events: visible;\n\n      > input {\n        cursor: pointer;\n        pointer-events: visible;\n      }\n    }\n\n    &.action-tooltips li.node i[title] {\n      display: block;\n      position: relative;\n      height: 100%;\n      width: 150px;\n      top: -25px;\n      left: 30px;\n    }\n  }\n\n  .dropdown-title-and-clear {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    > .clear-button {\n      background: white;\n      border: none;\n      color: red;\n      padding: 0;\n      padding-top: 2px;\n    }\n  }\n}\n\n.admin-dashboard-button,\n.admin-dashboard-button--disabled {\n  border-radius: 5px !important;\n  height: 2em;\n  font-family: Calibri, sans-serif !important;\n  width: calc(100% - 3em);\n  padding: 0 10px !important;\n}\n\n.admin-dashboard-button--disabled {\n  border-color: #808080;\n  color: #929292;\n}\n\n.assignments-breakdown-table {\n  border-spacing: 0;\n  td {\n    width: 0.1%;\n    white-space: nowrap;\n  }\n}\n\n.email-modal {\n  &.MuiFormControl-root {\n    margin: 0 !important;\n  }\n}\n\n.infinite-scroll-component {\n  max-height: 20em;\n  padding-bottom: 6px;\n  overflow: hidden;\n  padding-top: 6px;\n  > .node {\n    height: 1.8em;\n    > i {\n      font-style: normal;\n      margin: 0 2px;\n    }\n  }\n}\n\n.resource-popup {\n  > th {\n    font-family: Calibri, sans-serif !important;\n  }\n  > td {\n    font-family: Calibri, sans-serif !important;\n  }\n}\n\n.basic-button {\n  border: 1px solid black;\n  border-radius: 8px;\n  font-size: 1.6rem;\n  padding: 0 1em;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.75;\n  white-space: nowrap;\n\n  &.white {\n    background-color: #fff;\n    color: #000;\n\n    &.width-button {\n      min-width: 158px;\n    }\n  }\n\n  &.themed {\n    background-color: #1eabe3;\n    color: #fff;\n  }\n\n  &.small {\n    max-width: 100px;\n  }\n\n  &.medium {\n    max-width: 150px;\n  }\n\n  &.right-margin {\n    margin-right: 10px;\n  }\n}\n\n.cert-link {\n  font-size: 1em !important;\n  text-decoration: revert !important;\n}\n\n.text-align-right-inherit-padding {\n  text-align: right;\n  padding: inherit;\n}\n\n.text-align-right-no-padding {\n  text-align: right;\n  padding: 0px 0px !important;\n}\n\n.sidebar-icon-rows {\n  display: flex;\n  flex-direction: column;\n\n  > .help-center {\n    height: 56px !important;\n\n    > div > a {\n      font-size: 14px !important;\n    }\n\n    > div > a > div {\n      height: inherit;\n      margin: 17px 0px 0px 60px !important;\n    }\n  }\n}\n\n.sidebar-icon-row {\n  height: 40px;\n  padding: 0 !important;\n  margin-bottom: 3px;\n  display: flex;\n  justify-content: space-between;\n\n  > div {\n    padding: inherit;\n\n    > a > svg {\n      padding-left: 1px !important;\n      padding-right: 0;\n    }\n  }\n}\n\n#dashboard-footer {\n  text-align: center;\n  margin: 3.75em 0 0 0;\n  background-color: #e8e8e8;\n  box-shadow: unset !important;\n  justify-content: center;\n\n  & .dashboard-footer-text {\n    margin: 1em 0 !important;\n  }\n\n  & .footer-button-container {\n    flex: 6;\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    margin: 1.3em 0 0.75em 0 !important;\n\n    & button {\n      padding: 8px 12px;\n      text-transform: capitalize;\n\n      > img {\n        width: 24px !important;\n        height: 24px !important;\n        margin-right: 4px;\n      }\n    }\n  }\n}\n\n.section-header-container {\n  display: flex;\n  margin: 0 0;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n\n  & h4 {\n    margin-right: auto;\n  }\n\n  .section-nav-links {\n    margin-top: 5px !important;\n\n    .svgIcon {\n      height: 14px;\n      margin: 0 10px;\n      vertical-align: middle;\n      stroke: #000 !important;\n    }\n\n    & a {\n      text-underline-offset: 3px;\n      padding-bottom: 0px;\n      margin-bottom: 0px;\n    }\n\n    & a:hover {\n      color: #000;\n    }\n\n    & a:nth-of-type(1) {\n      margin-right: 20px;\n    }\n\n    & a:nth-last-of-type(1) {\n      margin-right: 10px;\n    }\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .countbox {\n    > .countbox-title {\n      font-size: 0.9vw;\n    }\n\n    > .countbox-count {\n      font-size: 1.3vw;\n    }\n  }\n}\n\n/*#region MUI Menu Customizations*/\n\n.ellipsis-menu {\n  > .MuiMenu-paper {\n    border: 1px solid #a4a4a4;\n    background-color: #f4f4f4;\n    border-radius: 3px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 3px;\n    margin-top: 4px;\n    > .MuiMenu-list {\n      padding: 0px;\n\n      > .MuiMenuItem-root {\n        padding: 3px;\n        justify-content: center;\n        align-items: center;\n        width: 55px;\n        height: auto;\n        font-size: 12px;\n        color: #444444;\n        line-height: normal;\n      }\n    }\n  }\n}\n/*#endregion*/\n\n.childcourse-container {\n  background-color: white;\n  color: black;\n  display: grid;\n  margin: 2em 0;\n  grid-template-columns:\n    [checkmark-col] 2em [image-col] calc(33.333% - 2em + 5px)\n    [text-col] auto;\n  /* the width of the image-col is 33% - 2em (from the checkmark-col) + 5px which is a third of the marginRight -15px that the CP has.\n  This way the right side of the child image lines up with the right side of the CP image */\n}\n\n.childcourse-item {\n  background-color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  margin-right: 0.97em;\n}\n\n.cc-checkmark-image-wrapper {\n  grid-column: 1 / span 2;\n  grid-row: 2 / span 2;\n}\n\n.cc-checkmark-image-combined {\n  grid-column: 1 / span 2;\n  grid-row: 2;\n  display: grid;\n  margin: 0;\n  grid-template-columns: [cc-checkmark-col] 2em [cc-image-col] auto;\n  align-content: center;\n  justify-items: center;\n}\n\n.cc-image-only {\n  margin-left: 0.5em;\n}\n\n.cc-checkmark-col {\n  grid-column: 1;\n  grid-row: 2;\n  padding-top: 2.5em;\n  align-content: stretch;\n}\n\n@media screen and (min-width: 1300px) {\n  .cc-checkmark-col {\n    padding-top: 3em;\n  }\n}\n\n@media screen and (min-width: 1500px) {\n  .cc-checkmark-col {\n    padding-top: 4em;\n  }\n}\n\n@media screen and (min-width: 1800px) {\n  .cc-checkmark-col {\n    padding-top: 5em;\n  }\n}\n\n.cc-checkmark-img {\n  height: 1em;\n  width: 1em;\n}\n\n.cc-image-cell {\n  grid-column: 2;\n  grid-row: 2 / span 2;\n  height: 0;\n  padding-bottom: 39.4%;\n}\n\n.cc-date-cell {\n  grid-column: 2;\n  grid-row: 1;\n}\n\n.cc-text-cell {\n  grid-column: 3;\n  grid-row: 2;\n  margin-left: 1em;\n}\n\n.cc-button-cell {\n  display: grid;\n  grid-column: 3;\n  grid-row: 3;\n  align-items: end;\n  margin-left: 1em;\n}\n\n.cc-button-container {\n  display: flex;\n  flex-direction: row;\n\n  & button {\n    margin-right: 10px;\n  }\n}\n\n.alert-component {\n  > .MuiAlert-icon {\n    padding: 9px 0;\n  }\n}\n\n.recommended-content-container {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
